'use strict';
import {InvitationLogin} from './components/InvitationLogin';
import {Login} from './components/Login';
import {MobileLogin} from './components/MobileLogin';
import {InvitationLoginController} from './controllers/InvitationLoginController';
import {InvitationRespondController} from './controllers/InvitationRespondController';
import {ApiKeysDomainProvider} from './domain/ApiKeysDomain';
import {
  APPLICATION_PERMISSION_CLASS_NAME,
  ApplicationPermissionDomainProvider,
} from './domain/ApplicationPermissionDomain';
import {PermissionDomainProvider} from './domain/PermissionDomain';
import {RoleDomainProvider} from './domain/RoleDomain';
import {UserConversationMetricsDomainProvider} from './domain/user-metrics/UserConversationMetricsDomain';
import {UserFileRequirementMetricsDomainProvider} from './domain/user-metrics/UserFileRequirementMetricsDomain';
import {UserProjectMetricsDomainProvider} from './domain/user-metrics/UserProjectMetricsDomain';
import {UserTaskMetricsDomainProvider} from './domain/user-metrics/UserTaskMetricsDomain';
import {UserDomainProvider} from './domain/UserDomain';
import {UserPreferenceDomainProvider} from './domain/UserPreferenceDomain';
import {DEFAULT_ROLES} from './enums/DEFAULT_ROLES';
import {routerConfig} from './router';
import {ApplicationPermissionsService} from './services/AppPermissionsService';
import {AuthCacheService, authCacheService} from './services/AuthCacheService';
import {AuthServiceProvider} from './services/AuthService';
import {PermissionsService} from './services/PermissionsService';
import {PermissionsVersionsService} from './services/PermissionsVersionsService';
import {RxPermissionsService} from './services/RxPermissionsService';
import {UserMetricsService} from './services/UserMetricsService';
import {UserPresenceService} from './services/UserPresenceService';
import {UserProfileService} from './services/UserProfileService';
import {injector as reduxListsInjector} from './utils/redux-lists';
import {NewUserWizard} from './wizards/NewUserWizard';
import {OrgInviteWizard} from './wizards/OrgInviteWizard';


const angular = require('angular');

module.exports = angular
  .module('app.auth', [])
  .config(routerConfig)
  .run(reduxListsInjector)
  .constant('DEFAULT_ROLES', DEFAULT_ROLES)
  .constant('InvitationLogin', InvitationLogin)
  .constant('Login', Login)
  .constant('MobileLogin', MobileLogin)

  .provider(APPLICATION_PERMISSION_CLASS_NAME, ApplicationPermissionDomainProvider)
  .provider('UserConversationMetricsDomain', UserConversationMetricsDomainProvider)
  .provider('UserFileRequirementMetricsDomain', UserFileRequirementMetricsDomainProvider)
  .provider('UserProjectMetricsDomain', UserProjectMetricsDomainProvider)
  .provider('UserTaskMetricsDomain', UserTaskMetricsDomainProvider)
  .provider('ApiKeysDomain', ApiKeysDomainProvider)
  .provider('PermissionDomain', PermissionDomainProvider)
  .provider('RoleDomain', RoleDomainProvider)
  .provider('UserDomain', UserDomainProvider)
  .provider('UserPreferenceDomain', UserPreferenceDomainProvider)

  .provider('AuthService', AuthServiceProvider)
  .service('applicationPermissionsService', ApplicationPermissionsService)
  .constant(AuthCacheService.SERVICE_NAME, authCacheService)
  .service('$permissions', PermissionsService)
  .service('rxPermissionsService', RxPermissionsService)
  .service('$permissionsVersions', PermissionsVersionsService)
  .service('userMetricsService', UserMetricsService)
  .service('userPresenceService', UserPresenceService)
  .factory('UserProfileService', UserProfileService)

  .service('NewUserWizard', NewUserWizard)
  .service('OrgInviteWizard', OrgInviteWizard)

  .controller('InvitationLoginController', InvitationLoginController)
  .controller('InvitationRespondController', InvitationRespondController)
;



// WEBPACK FOOTER //
// ./src/js/auth/index.js